module.exports = __webpack_public_path__ + "static/media/gallery10.6f4d0eb9.png";